module.exports = __webpack_public_path__ + "img/app_store.d86cba42.png";